import React from 'react';
import './StatusBar.css';

function StatusBar({ user, role, activeProject }) {
  return (
    <div className="status-bar">
      <span className="status-bar-item status-bar-left">KSEPro</span>
      <div className="status-bar-right">
        {activeProject && <span className="status-bar-item status-bar-project">⚡ {activeProject.name}</span>}
        {user && <span className="status-bar-item">{user?.username ?? user} [{role}]</span>}
      </div>
    </div>
  );
}

export default StatusBar;
